import { APP_VERSION } from '@/constants/appVersion'

const CHUNK_RELOAD_KEY = 'app-chunk-reload-attempted'

export async function fetchDeployedVersion(): Promise<string | null> {
  if (import.meta.env.DEV) return null

  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: 'no-store',
    })
    if (!response.ok) return null

    const data = (await response.json()) as { version?: string }
    return typeof data.version === 'string' ? data.version : null
  } catch {
    return null
  }
}

export function isNewerVersionAvailable(deployedVersion: string): boolean {
  if (!deployedVersion || deployedVersion === APP_VERSION) return false

  const current = APP_VERSION.split('.').map(Number)
  const deployed = deployedVersion.split('.').map(Number)
  const length = Math.max(current.length, deployed.length)

  for (let i = 0; i < length; i += 1) {
    const a = current[i] ?? 0
    const b = deployed[i] ?? 0
    if (b > a) return true
    if (b < a) return false
  }

  return deployedVersion !== APP_VERSION
}

export function reloadApp(): void {
  window.location.reload()
}

export function isChunkLoadError(reason: unknown): boolean {
  const message =
    reason instanceof Error
      ? reason.message
      : typeof reason === 'string'
        ? reason
        : ''

  return (
    message.includes('Loading chunk') ||
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed')
  )
}

export function reloadOnceOnChunkError(): void {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return
  sessionStorage.setItem(CHUNK_RELOAD_KEY, '1')
  reloadApp()
}
